import React from 'react'

function ToBeDeveloped() {
  return (
    <div className="px-6 pb-6 space-y-6">
        <ul>
            <li>Branche als 1:n Beziehung an Profile</li>
            <li>Actions für Abgleich von
                <ul>
                    <li>Branche mit Referenzdatenbank companyIdent: huk%coburg, branche: versicherungen</li>
                    <li>Email mit Referenzdatenbank companyIdent: huk%coburg, domain: huk-coburg.de emailpattern: firstname.lastname</li>
                    <li>Gender mit Referenzdatenbank firstnameIdent: bjoern gender: male</li>
                </ul>
            </li>
            <li>Destructive Import von CSV nach Referenzdatenbank</li>
        </ul>
    </div>
  )
}

export default ToBeDeveloped